import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";

export const Footer = () => (
    <footer data-testid="site-footer" className="relative overflow-hidden border-t border-red-950/60">
        <div
            className="pointer-events-none absolute inset-0 opacity-[0.08]"
            style={{
                backgroundImage:
                    "url(https://images.unsplash.com/photo-1646872223685-ca4c51fc315d?crop=entropy&cs=srgb&fm=jpg&q=85)",
                backgroundSize: "cover",
                backgroundPosition: "center",
            }}
        />
        <div className="relative mx-auto max-w-7xl px-6 py-16 sm:px-12">
            <p className="font-display text-3xl font-extrabold leading-none tracking-tight text-red-950 sm:text-5xl lg:text-6xl">
                LOGAN'S
            </p>
            <p className="mt-2 font-editorial text-xl italic text-red-800 sm:text-2xl">
                Reptiles &amp; Exotics
            </p>

            <div className="mt-12 grid grid-cols-1 gap-10 border-t border-red-950/50 pt-10 md:grid-cols-2">
                <div>
                    <p className="font-mono2 text-[10px] uppercase tracking-[0.3em] text-red-500">Explore</p>
                    <div className="mt-3 flex flex-col gap-2 text-sm">
                        <Link to="/shop" data-testid="footer-shop-link" className="text-ash transition-colors duration-300 hover:text-red-400">Shop the Collection</Link>
                        <Link to="/#manifesto" data-testid="footer-manifesto-link" className="text-ash transition-colors duration-300 hover:text-red-400">Our Manifesto</Link>
                        <Link to="/terms" data-testid="footer-terms-link" className="text-ash transition-colors duration-300 hover:text-red-400">Terms of Service</Link>
                        <Link to="/track" data-testid="footer-track-link" className="text-ash transition-colors duration-300 hover:text-red-400">Track Your Order</Link>
                    </div>
                </div>
                <div>
                    <p className="font-mono2 text-[10px] uppercase tracking-[0.3em] text-red-500">Guarantee</p>
                    <p className="mt-3 flex items-start gap-2 text-sm text-ash">
                        <ShieldCheck className="mt-0.5 h-4 w-4 shrink-0 text-emerald-500" />
                        Live arrival guaranteed on every animal. 100% captive bred. Lifetime keeper support with every purchase.
                    </p>
                </div>
            </div>

            <p className="mt-12 border-t border-red-950/40 pt-6 font-mono2 text-[10px] uppercase tracking-[0.2em] text-ash/50">
                © {new Date().getFullYear()} Logan's Reptiles &amp; Exotics · Venomous species sold to verified keepers only · All sales subject to local regulations
            </p>
        </div>
    </footer>
);
